import { ApiResponse } from "interface/response";
import { AxiosApi } from "./index";
import { FilterOption } from "interface/index";
import { PurchaseOverview, OpenStatistics, FreshSale, FrozenSales, FrozenSalesWeekly, SalesStatistics } from "interface/sales";
import { AuctionedVesselQuota } from "interface/auction";
import { useInfoStore } from "store/error";

export interface PurchaseOverviewFilter extends FilterOption {
    buyerLedgerAccountNumber?: string,
    buyerName?: string,
    buyerId?: string,
    vesselLedgerAccountNumber?: string,
    vesselName?: string
    vesselId?: string
    salesNumber?: string,
    contractNumber?: string,
    auctionNumber?: string,
}
export interface StorageStatisticFilter extends FilterOption {
    speciesCode?: string
    species?: string
}
export interface FrozenSalesWeeklyFilter extends FilterOption {
    fishingGearId?: number
    speciesCode?: string
    fishingGear?: string
    species?: string
}
export interface   SalesStatisticsFilter extends FilterOption {
    fishingGearId?: number
    speciesCode?: string
    fishingGear?: string
    species?: string
    buyerName?: string,
    buyerId?: string
    vesselName?: string
    vesselId?: any
    product?: string
    productId?: string,
    preservation?: string
    preservationId?: string
}

export interface OpenStatisticsFilter extends SalesStatisticsFilter {
}


export async function getPurchaseOverviewApi(params: PurchaseOverviewFilter) {
    const apiUri = "Sales/Overview";

    console.log('PurchaseOverviewFilter', params);

    try {
        const sales = await AxiosApi.get<ApiResponse<PurchaseOverview[]>>(apiUri, { params: { ...params } });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}


export async function getPurchaseOverviewLinesApi({ salesId, source }: { salesId: number; source: number }) {
    const apiUri = "Sales/OverviewLines";
    try {
        const sales = await AxiosApi.get<ApiResponse<PurchaseOverview[]>>(apiUri, { params: { source, salesId } });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}


export async function getFreshSaleApi(filterOptions: FilterOption) {
    const apiUri = "Sales/Fresh";
    try {
        const sales = await AxiosApi.get<ApiResponse<FreshSale[]>>(apiUri, { params: filterOptions });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getFrozenSaleApi(filterOptions: FilterOption) {
    const apiUri = "Sales/Frozen";
    try {
        const sales = await AxiosApi.get<ApiResponse<FrozenSales[]>>(apiUri, { params: filterOptions });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getFrozenSaleWeeklyApi(filterOptions: FrozenSalesWeeklyFilter) {
    const apiUri = "Sales/FrozenWeekly";
    try {
        const sales = await AxiosApi.get<ApiResponse<FrozenSalesWeekly[]>>(apiUri, { params: filterOptions });
        return sales.data.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getSalesStatisticsApi(filterOptions: SalesStatisticsFilter) {
    const apiUri = "Sales/Statistics";
    try {
        const sales = await AxiosApi.get<ApiResponse<SalesStatistics[]>>(apiUri, { params: filterOptions });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getOpenStatisticsApi(filterOptions: OpenStatisticsFilter) {
    const apiUri = "Sales/OpenedStatistics";
    try {
        const sales = await AxiosApi.get<ApiResponse<OpenStatistics[]>>(apiUri, { params: filterOptions });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getStorageStatisticsApi(filterOptions: StorageStatisticFilter) {
    const apiUri = "Sales/StorageStatistics";
    try {
        const sales = await AxiosApi.get<ApiResponse<SalesStatistics[]>>(apiUri, { params: filterOptions });
        return sales.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}



export interface AuctionFilter {
    quotaYear?: number,
    vesselId?: string,
    vesselRegistrationNumber?: string,
    vesselName?: string,
}

export async function getUserAuctionedDataApi(filter: AuctionFilter) {
    const apiUri = "Sales/AuctionedWeight";
    try {
        const invoices = await AxiosApi.get<ApiResponse<AuctionedVesselQuota[]>>(apiUri, { params: filter });
        return invoices.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
